import React from 'react';
import styled from 'styled-components';

const ButtonWrapper = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 39px;
  min-width: 251px;
  border-radius: 3px;
  box-shadow: none;
  font-size: 12px;
  font-weight: 700;
  padding: 9px 0;
  text-decoration: none;
  text-transform: uppercase;
  transition:
    background-color 200ms,
    color 200ms;

  background-color: ${(props: any) => props.theme.carvana.blue.primary};
  border: 1px solid ${(props: any) => props.theme.carvana.blue.primary};
  color: ${(props: any) => props.theme.carvana.white.primary};

  &:hover {
    background-color: ${(props: any) => props.theme.carvana.blue.hover};
    border: 1px solid ${(props: any) => props.theme.carvana.blue.hover};
    color: ${(props: any) => props.theme.carvana.white.primary};
    cursor: pointer;
    text-decoration: none;
  }
`;

type OwnProps = React.HTMLProps<HTMLAnchorElement> & {
  dataCvTest?: string;
};

const Button = ({ children, className, dataCvTest, href, ...rest }: OwnProps) => (
  <ButtonWrapper href={href} className={className} data-cv-test={dataCvTest} {...rest}>
    {children}
  </ButtonWrapper>
);

export default Button;
